import { AffiliatePartner, CreateUpdateAffiliatePartner } from "./types";

export const convertAffiliatePartnerToCreateUpdateObject = (
  affiliate: AffiliatePartner
): CreateUpdateAffiliatePartner => {
  const { createdAt, updatedAt, id, ...data } = affiliate;

  return data;
};
